import { Link } from 'react-router-dom';

import HomeImg from '../assets/images/home.png';
import { IoIosSearch } from 'react-icons/io';

const Hero = () => {
  return (
    <section id='hero' className='bg-gradient-to-b from-primary to-[#eeece3]'>
      <div className='container flex flex-col-reverse items-start px-6 mx-auto pt-20 py-10 space-y-0 md:space-y-0 md:flex-row'>
        <div className='flex flex-col mb-32 space-y-4 md:w-1/2'>
          {/* <h1 className='max-w-md text-4xl text-center md:text-5xl md:text-left font-display text-text'>
            AudPro
          </h1> */}
          <span className='max-w-md text-4xl text-center md:text-5xl md:text-left font-display text-text'>
            Conformidade tributária: <span className='italic text-textLight'> garanta o sucesso de suas negociações</span>
          </span>
          <p className='max-w-sm text-center text-tex md:text-left pt-4 pb-4'>
            A complexidade da Reforma Tributária não precisa ser um obstáculo para o crescimento do seu negócio.
          </p>
          <div className='flex justify-center md:justify-start'>
            <Link
              to='/classificacao-tributaria'
              className='p-3 flex flex-row items-center gap-2 px-6 pt-2 text-white bg-brightRed rounded-full baseline hover:bg-brightRedLight'
            >
              <IoIosSearch />
              <p>Consultar classificação tributária</p>
            </Link>
          </div>
        </div>
        <div className='md:w-1/2'>
          <img src={HomeImg} alt='' className='rounded-lg' />
        </div>
      </div>
    </section>
  );
};

export default Hero;
